import { useMemo } from "react";
import { v1 as uuidv1 } from "uuid"; // TODO: after upgrade to react 18 migrate to built-in useId

export function safeID(idPrefix: string): (idSuffix: string) => string {
  const staticUuid = uuidv1();

  return (idSuffix: string): string => {
    const prefix = `${idPrefix}${idPrefix !== "" ? "_" : "i"}`;
    const suffix = idSuffix ? `_${idSuffix}` : "";
    return `${prefix}${suffix ? staticUuid : uuidv1()}${suffix}`;
  };
}

interface IUseSafeID {
  prefix?: string;
  suffix?: string;
  id?: string;
}

export function useSafeID({ prefix, suffix, id }: IUseSafeID): string {
  return useMemo<string>(() => id || safeID(prefix || "")(suffix || ""), [id, prefix, suffix]);
}

